import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';
import { validateArrayType } from './utils/validate-array';
import { ClientIntegrationApi, ClientIntegrationApiClient } from '@sg/api/client-integration-api';

type ClientIntegrationsSearchRequest = {
  isInternal?: boolean;
  allowManualUpload?: boolean;
  name?: string;
  ids?: Array<string>;
};

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    ClientIntegrations: {
      entity: ClientIntegrationApi.ClientIntegrationDto;
      query: ClientIntegrationsSearchRequest;
    };
  }
}

export class ClientIntegrationApiToEntityFetcherLink implements SgEntityFetchAdapter<'ClientIntegrations'> {
  readonly key: 'ClientIntegrations' = 'ClientIntegrations';
  readonly metadata: {
    idField: keyof ClientIntegrationApi.ClientIntegrationDto;
    labelField: keyof ClientIntegrationApi.ClientIntegrationDto;
    queryField?: { field: keyof ClientIntegrationsSearchRequest; isArray?: boolean };
  } = {
    idField: 'id',
    labelField: 'name',
    queryField: { field: 'name' },
  };

  private readonly _clientIntegrationApi: ClientIntegrationApiClient;

  constructor(injector: Injector) {
    this._clientIntegrationApi = injector.get(ClientIntegrationApiClient);
  }

  getEntity(ids: string[]) {
    const body: ClientIntegrationsSearchRequest = { ids: validateArrayType(ids) };
    return this._clientIntegrationApi
      .clientIntegrationControllerSearchIntegrations({ body }, { observe: 'body' })
      .pipe(map((result) => (result?.length ? result[0] : [])));
  }

  findEntities(query?: ClientIntegrationsSearchRequest) {
    const body: ClientIntegrationsSearchRequest = {};
    if (query) {
      Object.assign(body, query);
    }
    if (query.name) {
      Object.assign(body, { ...body, name: undefined, names: [query.name] });
    }

    return this._clientIntegrationApi.clientIntegrationControllerSearchIntegrations({ body }, { observe: 'body' }).pipe(
      map((result) => {
        return { data: result ?? [] };
      })
    );
  }
}
